import ChatTranscript from "./ChatTranscript";

export const dynamicParams = false;

export function generateStaticParams() {
  return [];
}

export default async function ChatTranscriptPage({
  params,
}: {
  params: Promise<{ id: string }>;
}) {
  const { id } = await params;
  return <ChatTranscript id={id} />;
}
